export default __webpack_public_path__ + "static/media/freja-insights.872ae13b.svg";